module.exports = __webpack_public_path__ + "static/media/efsa.0a60326b.png";